import React, { useEffect } from 'react'
import { withAppContext } from 'src/store/initAppContext';
import styled, { withTheme } from 'styled-components';
import { LazyLoadImage } from "react-lazy-load-image-component";
import config from "src/config/config";
import PlaceholderImage from 'src/components/Placeholder';
import { theme } from 'styled-tools';
import { Link } from 'react-router-dom';

function HundredExchangeSafetyPromo(props) {
    const { app: {
        brandId
    }, theme } = props;

    useEffect(() => {
        window.scrollTo(0, 0)
    }, [])

    const domain = (brandId == 31 || brandId == 32 || brandId == 61) ? "YOLO247" : (brandId == 39 || brandId == 40) ? "FOMO7" : 'iW247';


    return (
        <>
            <InformationWrapper>
                <Container>
                    <HESTopSec>
                        <LazyLoadImage
                            src={`${config.imageV3Host}/static/cashsite/${theme.image.exchangeSafetyFirstSecDesk}`}
                            alt="exchange safety top"
                            effect="none"
                            placeholder={<PlaceholderImage />}
                        />
                        <Link to="/betting-exchange">
                            <img 
                                src={`${config.imageV3Host}/static/cashsite/${theme.image.exchangeSafetyFirstSecBtnDesk}`} 
                                className="hesTopSecBtn" 
                                alt="" 
                            />
                        </Link>

                    </HESTopSec>
                    <HESMidSec>
                        <img 
                            src={`${config.imageV3Host}/static/cashsite/${theme.image.exchangeSafetyNumbersDesk}`} 
                            className="hesMidNumber" 
                            alt="" 
                        />
                        <HESMidSecSteps>
                            <img
                                src={`${config.imageV3Host}/static/cashsite/${theme.image.exchangeSafetySteps01Desk}`}
                                className=""
                                alt=""
                            />
                            <img
                                src={`${config.imageV3Host}/static/cashsite/${theme.image.exchangeSafetySteps02Desk}`}
                                className=""
                                alt=""
                            />
                            <img
                                src={`${config.imageV3Host}/static/cashsite/${theme.image.exchangeSafetySteps03Desk}`}
                                className=""
                                alt=""
                            />
                        </HESMidSecSteps> 
                    </HESMidSec>
                    <HESLastSec>
                        <img
                            src={`${config.imageV3Host}/static/cashsite/${theme.image.exchangeSafetyTermsLeftDesk}`}
                            className=""
                            alt=""
                        />
                        <TermsSec>
                            <ul>
                                <li>Valid from <strong>01 Jan 2026 to 28 Feb 2026</strong></li>
                                <li><strong>Applicable on Exchange bets only for: BBL, SA20, WPL </strong></li>
                                <li><strong>Only the first losing bet of the day is eligible</strong></li>
                                <li><strong>100% betback up to {brandId === 61 ? "$5" : "₹50"}</strong></li>
                                <li><strong>Maximum benefit per player per day: {brandId === 61 ? "$5" : "₹50"}</strong></li>
                                <li>Betback credited as a<strong> non-withdrawable bonus</strong></li>
                                <li><strong>Bonus wagering requirements apply</strong></li>
                                <li><strong>Estimated total promotion pool: {brandId === 61 ? "$75,000" : "₹75,00,000"} </strong></li>
                                <li>{domain} reserves the right to <strong>modify, suspend, or cancel</strong> the promotion without prior notice</li>
                                <li><strong>General {domain} terms & conditions apply</strong></li>
                            </ul>
                        </TermsSec>
                    </HESLastSec>
                </Container>

            </InformationWrapper>
        </>
    )
}

export default withTheme(withAppContext(HundredExchangeSafetyPromo));

const InformationWrapper = styled.div`
    width: 98%;
    height: auto;
    padding: 4rem 0 5rem 0;
    margin: 0em 1.2em 0 1.2em;
    border: 1px solid #fff;  
    display: flex;
    flex-direction: column;
    align-items: center;
    background: url(${config.imageV3Host}/static/cashsite/${theme("image.exchangeSafetyInnerBgDesk")});
    background-position: center;
    background-size: cover;
    background-repeat: no-repeat;
    overflow: hidden;
    color: #fff;
    text-transform: capitalize;

    .staticImg2 {
        width: 100%;
        max-width: 910px;
        display: flex;
        align-items: center;
        justify-content: center;

        img {
            max-width: 100%;
        }
    }
`;

const Container = styled.div`
    width: 100%;
    max-width: 1100px;
    display: flex;
    align-items: center;
    flex-direction: column;


`;

const HESTopSec = styled.div`
    width: 100%;
    height: auto;
    margin: 0;
    position: relative;

    & img {
        width: 100%;
        height: auto;
        object-fit: contain;
    }

    .hesTopSecBtn {
      position: absolute;
      bottom: 21%;
      right: 20%;
      width: 200px;
      height: 50px;
    }
`

const HESMidSec = styled.div`
    width: 100%;
    height: auto;
    margin: 1em 0;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 30px;

    & img {
        width: 100%;
        height: auto;
        object-fit: contain;
    }

    .hesMidNumber {
       width: 30%;
       height: auto;
    }
`

const HESMidSecSteps = styled.div`
    display: flex;
    gap: 5px;
    width: 100%;
    height: auto;

    & img {
        width: 33%;
        height: auto;
    }
`

const HESLastSec = styled.div`
    width: 100%;
    height: auto;
    display: flex;
    justify-content: center;
    gap: 5px;

    & img {
        width: 40%;
        height: auto;
        object-fit: contain;
    }

`

const TermsSec = styled.div`
    display: flex;
    flex-direction: column;
    gap: 3px;
    width: 60%;
    height: auto;


    ul {
        & li {
            color: #FFF;
            font-size: 16px;
            font-style: normal;
            font-weight: 400;
            line-height: 27px; /* 168.75% */
            text-transform: capitalize;
            margin: 8px 0px;
            background: ${theme('palette.hundredExchangeSafetyPromoTermsBg')};
            padding: 5px 5px 5px 15px;
            list-style-type: none;
        }
    }
`